<template>
	<div class="page">
		<NavBar
			fixed
			:title="title"
			left-arrow
			@click-left="$router.back()"
		/>
		<div v-html="content" style="padding: 0px 15px; overflow: auto; height: calc(100vh - 48px);"/>
	</div>
</template>

<script>
	import { NavBar } from 'vant';
	export default {
	  components: {NavBar},
	  data() {
			return {
        content: '',
				title: ''
			}
	  },
    created() {
	    this.content = this.$route.params.content;
	    this.title = this.$route.params.heading;
		}
	}
</script>

<style
	scoped
	lang="less">
  .page {
	  padding-top: 46px;
	  background: #fff;
  }
  p {
	  line-height: 26px;
	  text-indent: 2ch;
	  margin: 10px 0px;
  }
  p, div, span, * {
	  font-family: inherit !important;
	  background-color: #fff !important;
	  line-height: 26px !important;
	  font-size: 14px !important;
  }
</style>
